import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

interface DeleteInjuryDialogProps {
    open: boolean;
    injuryName: string;
    onClose: () => void;
    onConfirm: () => void;
    loading: boolean;
}

export default function DeleteInjuryDialog({
    open,
    injuryName,
    onClose,
    onConfirm,
    loading,
}: DeleteInjuryDialogProps) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Удалить травму</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Удалить травму <strong>{injuryName}</strong>? Характеристики бойца будут восстановлены.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Отмена
                </Button>
                <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
                    {loading ? 'Удаление...' : 'Удалить'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
